const SaleHyfye = ()=> {
  return (
    <section id="token" className="section_token token_sale overflow_hide">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12">
            <div className="title_dark title_border text-center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Hyfye Token Sale</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Join the Hyfye Web3 revolution. 60 Billion HYE tokens are available for early contributors. By participating, you fuel a real-world utility token driving finance, content, games, fitness, and social apps — all with one ecosystem.
              </p>
            </div>
          </div>
        </div>

        <div className="row small_space">
          <div className="col-lg-4">
            <div className="token_info_table h-100">
              <table className="table table-dark m-0 h-100">
                <tbody>
                  <tr><td>Start Date:</td><td>July 21, 2025</td></tr>
                  <tr><td>End Date:</td><td>July 27, 2025</td></tr>
                  <tr><td>Soft Cap:</td><td>5 BNB</td></tr>
                  <tr><td>Token:</td><td>HYE (Hyfye Token)</td></tr>
                  <tr><td>Tokens for Sale:</td><td>60 Billion HYE (6%)</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="bg_black_dark token_dt res_md_mt_30 res_xs_mt_20">
              <div className="row align-items-center h-100">
                <div className="col-lg-7">
                  <div className="tk_counter_inner text-center">
                    <div className="progress animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                      <div className="progress-bar progress-bar-striped gradient" role="progressbar" style={{width:"10%"}}> 0% </div>
                      <span className="progress_label bg-white" style={{left: "1%"}}> <strong> 0 HYE </strong></span>
                      <span className="progress_label bg-white" style={{left: "98%"}}> <strong> 60B HYE </strong></span>
                      <span className="progress_min_val">Sale Raised</span>
                      <span className="progress_max_val">Target Cap</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="token_detail text-center">
                    <ul className="list_none">
                      <li><h4>1 HYE =</h4><span>N/A</span></li>
                      <li><h4>Total Presale Value:</h4><span>≈ (N/A)</span></li>
                      <li><h4>Presale Type:</h4><span>Early Access Presale</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>  
          </div>
        </div>

        <div className="divider large_divider"></div>
        <div className="row">
          {/* Use of Funds */}
          <div className="col-lg-5 col-md-12">
            <div className="title_dark title_border text-center">
              <h4>Use of Funds</h4>
              <p>Funds raised will be allocated to accelerate Hyfye's development, scale marketing efforts, ensure liquidity, and support global expansion within the Web3 economy.</p>
            </div>
            <ul className="list_none chart_list">
              <li><h6>Platform Development</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "25%"}}>25%</div></div></li>
              <li><h6>Marketing & Outreach</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "35%"}}>20%</div></div></li>
              <li><h6>Liquidity</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "35%"}}>35%</div></div></li>
              <li><h6>Buyback & Reserves</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "16%"}}>16%</div></div></li>
              <li><h6>Team & Operations</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "10%"}}>5%</div></div></li>
            </ul>
          </div>

          <div className="col-lg-2"></div>

          {/* Token Distribution */}
          <div className="col-lg-5 col-md-12">
            <div className="title_dark title_border text-center">
              <h4>Token Distribution</h4>
              <p>1T HYE are allocated to fuel ecosystem growth, enhance liquidity, and drive innovation across the Hyfye platform.</p>
            </div>
            <ul className="list_none chart_list">
              <li><h6>Public Presale</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "6%"}}>6%</div></div></li>
              <li><h6>Liquidity/Exchanges/Buyback Reserve</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "35%"}}>35%</div></div></li>
              <li><h6>Development, Marketing, Infra</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "35%"}}>35%</div></div></li>
              <li><h6>Ecosystem Reserve</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "21%"}}>21%</div></div></li>
              <li><h6>Other</h6><div className="progress bg-blue"><div className="progress-bar" style={{width: "3%"}}>3%</div></div></li>
            </ul>
          </div>
        </div>

        <div className="divider large_divider"></div>
      </div>
    </section>
  );
};

export default SaleHyfye;
